import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import LocalSeeIcon from "@material-ui/icons/LocalSee";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
export default function ShowPicture(props) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <ListItemSecondaryAction>
        <IconButton
          onClick={handleClickOpen}
          edge="end"
          aria-label="Voir le plan"
        >
          <Tooltip title="Voir le plan">
            <LocalSeeIcon className="black" />
          </Tooltip>
        </IconButton>
      </ListItemSecondaryAction>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <IconButton
          className="close-dialog"
          edge="start"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
        >
          <CloseIcon className="light-blue" />
        </IconButton>
        <DialogContent>
          <img src={props.picture} alt="" />
        </DialogContent>
      </Dialog>
    </div>
  );
}

ShowPicture.propTypes = {
  picture: PropTypes.string
};
